module.exports = __webpack_public_path__ + "static/media/20.c5b306a6.JPG";